module.exports = __webpack_public_path__ + "static/media/Artboard12.60ecccbb.png";